import React from "react";

type HistoryItem = { date: string; planName: string; status: string };

export default function WorkoutHistory({ items }: { items: HistoryItem[] }) {
  return (
    <div style={styles.card}>
      <div style={styles.cardHeader}>
        <strong>Workout History</strong>
      </div>
      {items.length === 0 && (
        <div style={styles.empty}>No workouts logged yet.</div>
      )}
      {items.map((it) => (
        <div key={it.date} style={styles.historyRow}>
          <span>{new Date(it.date).toLocaleDateString()}</span>
          <span style={styles.historyPlan}>{it.planName}</span>
          <span style={styles.historyStatus}>{it.status}</span>
        </div>
      ))}
    </div>
  );
}

const styles: { [k: string]: React.CSSProperties } = {
  card: { backgroundColor: "#2a2a2a", borderRadius: 8, padding: 12 },
  cardHeader: { fontWeight: 700, marginBottom: 6 },
  empty: { color: "#bbb" },
  historyRow: {
    display: "flex",
    justifyContent: "space-between",
    padding: "6px 0",
    borderBottom: "1px solid #333",
  },
  historyPlan: { color: "#ddd" },
  historyStatus: { color: "#9acd32" },
};
